import React from "react";

function FAQ() {
  return (
    <>
      <div className="container mb-4">
        <div className="d-flex align-items-center mt-4 mb-1">
          <div className="heading-dash" />
          <h5 className="fw-bold mb-0 d-flex align-items-center">
            {/* <SiSitepoint className="me-2" size={20} /> */}
            Frequently Asked Questions
          </h5>
        </div>
        <div class="faq-content">
          <div class="faq-question">
            <input id="q1" type="checkbox" class="panel" />
            <div class="plus">+</div>
            <label for="q1" class="panel-title">
              How can I book a taxi in Dibrugarh?
            </label>
            <div class="panel-content">
              You can easily book a taxi through the DibruGo website by entering
              your pickup and drop location. Choose your ride type and confirm
              your booking in just a few seconds.
            </div>
          </div>

          <div class="faq-question">
            <input id="q2" type="checkbox" class="panel" />
            <div class="plus">+</div>
            <label for="q2" class="panel-title">
              Does DibruGo provide local taxi service in Dibrugarh?
            </label>
            <div class="panel-content">
              Yes, DibruGo provides reliable local taxi services within
              Dibrugarh, making it easy for customers to travel for work,
              shopping, or daily commuting.
            </div>
          </div>

          <div class="faq-question">
            <input id="q3" type="checkbox" class="panel" />
            <div class="plus">+</div>
            <label for="q3" class="panel-title">
              Can I book intercity taxis from Dibrugarh?
            </label>
            <div class="panel-content">
              Yes, DibruGo offers intercity taxi services from Dibrugarh to
              nearby cities and towns with comfortable vehicles and experienced
              drivers.
            </div>
          </div>

          <div class="faq-question">
            <input id="q4" type="checkbox" class="panel" />
            <div class="plus">+</div>
            <label for="q4" class="panel-title">
              Can I reserve a taxi in advance?
            </label>
            <div class="panel-content">
              Yes, DibruGo allows customers to reserve taxis in advance for
              planned trips, airport transfers, or multi-day bookings.
            </div>
          </div>

          <div class="faq-question">
            <input id="q5" type="checkbox" class="panel" />
            <div class="plus">+</div>
            <label for="q5" class="panel-title">
              Does DibruGo provide airport pickup and drop?
            </label>
            <div class="panel-content">
              Yes, DibruGo provides convenient airport taxi services to and from
              Dibrugarh Airport.
            </div>
          </div>

          <div class="faq-question">
            <input id="q6" type="checkbox" class="panel" />
            <div class="plus">+</div>
            <label for="q6" class="panel-title">
              Is DibruGo taxi service available 24/7?
            </label>
            <div class="panel-content">
              DibruGo aims to provide reliable taxi services anytime, allowing
              customers to book rides whenever they need transportation.
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FAQ;
